import { render, staticRenderFns } from "./CircleFeatureList.vue?vue&type=template&id=324b0929&scoped=true"
import script from "./CircleFeatureList.vue?vue&type=script&lang=js"
export * from "./CircleFeatureList.vue?vue&type=script&lang=js"
import style0 from "./CircleFeatureList.vue?vue&type=style&index=0&id=324b0929&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "324b0929",
  null
  
)

export default component.exports